var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-layout',[_c('v-flex',{staticClass:"label"},[_c('span',{staticClass:"default_gray ma-1"})]),_c('v-flex',[_c('span',{staticClass:"default_gray ma-1",style:({ width: _vm.item.shimmerWidth })})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }